// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".monaco-editor .margin-view-overlays .cmdr{position:absolute;left:0;width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
